export default "__VITE_ASSET__BBkNgAss__"